export default __webpack_public_path__ + "static/media/BellActive.22dcd46b.svg";